import { AlpineComponent } from 'alpinejs';
import { Dropdown } from 'bootstrap';

const SCROLL_DELTA = 50;

interface DomSlider {
  slideDown(options: { element: Element }): void;
  slideUp(options: { element: Element }): void;
  slideToggle(options: { element: Element }): void;
}

declare global {
  interface Window {
    domSlider: DomSlider;
  }
}

type HeaderData = {
  isHidden: boolean,
  isSearchOpened: boolean,
  lastScrollPosition: number,
  toggleMobileNav: () => void,
  toggleSubNav: (event: Event) => void,
  showSearch: () => void,
}

export default ():AlpineComponent<HeaderData> => ({
  isHidden: false,
  isSearchOpened: false,
  lastScrollPosition: 0,

  init() {
    this.lastScrollPosition = window.pageYOffset;

    window.addEventListener('scroll', () => {
      if (window.pageYOffset >= 0) {
        if (Math.abs(window.pageYOffset - this.lastScrollPosition) >= SCROLL_DELTA) {
          this.isHidden = window.pageYOffset >= this.lastScrollPosition;
          this.lastScrollPosition = window.pageYOffset;
        }
      }
    });

    const dropdownElements = (this.$root as HTMLElement).querySelectorAll('[data-bs-toggle="dropdown"]');
    if (dropdownElements.length) {
      dropdownElements.forEach(item => new Dropdown(item as HTMLElement));
    }
  },

  toggleMobileNav () {
    const mobileNav = this.$root.querySelector('.mobile-nav');
    if (mobileNav) {
      document.body.classList.toggle('mobile-nav-opened');
      if (document.body.classList.contains('mobile-nav-opened')) { // opening mobile nav
        const activeNavItems:Array<HTMLElement> = [];
        Array.from<HTMLAnchorElement>(mobileNav.querySelectorAll('a.active')).forEach((link) => {
          const activeNavItem = link.parentElement;
          if (activeNavItem && activeNavItem.classList.contains('sub')) {
            activeNavItems.push(activeNavItem);
          }
        });
        activeNavItems.forEach((item) => {
          item.classList.add('js-opened');
          const navElement = item.querySelector('nav');
          if (navElement) {
            window.domSlider.slideDown({ element: navElement });
          }
        });
      } else { // closing mobile nav
        Array.from<HTMLAnchorElement>(mobileNav.querySelectorAll('.js-opened')).forEach((item) => {
          item.classList.remove('js-opened');
          const navElement = item.querySelector('nav');
          if (navElement) {
            window.domSlider.slideUp({ element: navElement });
          }
        });
      }
    }
  },

  toggleSubNav(event: Event) {
    const eTarget = event.target as HTMLElement;
    const navItem = eTarget.parentElement;
    if (navItem?.classList.contains('sub')) {
      event.preventDefault();
      navItem.classList.toggle('js-opened');
      const navElement = navItem.querySelector('nav');
      if (navElement) {
        window.domSlider.slideToggle({ element: navElement });
      }
    }
  },

  showSearch() {
    const search = this.$root.querySelector('.header-search');
    if (search) {
      search.classList.add('opened');
      const searchInput = document.querySelector('.header-search-input');
      if (searchInput) {
        searchInput.setAttribute('autofocus', 'autofocus');
      }
    }
  }
});
